import Preparation from "./views/Prepration";
import Affirmation from "./views/Affirmation";
import Communication from "./views/Communication/Communication";
import Frequency from "./views/Frequency/Frequency";
import Gates from "./views/Gates/Gates";
import Learning from "./views/Learning/Learning";
import Train from "./views/Train/Train";
import Playlists from "./views/Playlists/Playlists";
import FAQ from "./views/FAQ/FAQ";
import Description from "./views/Description/Description";
import AutoLogin from "./views/AutoLogin/AutoLogin";
import Portal from "./views/Portal";
import SalMagicFAQ from "./views/FAQ/SalMagicFAQ";
import PureTones from "./views/Frequency/SalMagic/PureTones";
import OtherSources from "./views/Frequency/SalMagic/OtherSources";
import TermsAndConditions from "./views/termsAndConditions/TermsAndConditions";
import FreeTrialCallback from "./views/Subscription/FreeTrialCallback";
import {
  PORTAL_ROUTE,
  VALUES_ROUTE,
  PURPOSES_ROUTE,
  VISIONS_ROUTE,
  MISSIONS_ROUTE,
  SALPLAN_ROUTE_DETAILS,
  SALPLAN_ROUTE,
  FOCUS_POSTER_ROUTE_DETAILS,
  FOCUS_POSTER_ROUTE,
  PREPARATION_ROUTE,
  INTENTION_ROUTE,
  STORY_ROUTE,
  MAGIC_ROUTE,
  PROBLEM_ROUTE,
  AREA_ROUTE,
  PERSONAL_ROUTE,
  CLEAR_AND_PROTECT_ROUTE,
  SUBLIMINAL_AUDIO_ROUTE,
  SUBLIMINAL_ROUTE,
  CREATEPOSSIBILITY_ROUTE,
  AFFIRMATION_ROUTE,
  ARCHIVE_ROUTE,
  SESSION_ROUTE,
  TAPPING_ROUTE,
  NINE_G_ROUTE,
  HEALING_ROUTE,
  DETAIL_ROUTE,
  INNER_ROUTE,
  PARTS_ROUTE,
  DISEASE_ROUTE,
  COMMUNICATION_ROUTE,
  WAVE_DETAIL_ROUTE,
  WAVES_ROUTE,
  SOLFEGGIO_ROUTE,
  CHAKRAS_ROUTE,
  FREQUENCY_ROUTE,
  BALANCE_GATE_ROUTE,
  MANIFESTATION_GATE_ROUTE,
  GATE_ROUTE,
  LOGIN_SMARTSWAY_ROUTE,
  LEARN_ROUTE,
  TRAIN_ROUTE,
  PLAYLISTS_ROUTE,
  FAQ_ROUTE,
  T_C_ROUTE,
  SAL_MAGIC_FAQ_ROUTE,
  DESCRIPTION_ROUTE,
  PURE_TONES_ROUTE,
  OTHER_SOURCES_ROUTE,
} from "./routePaths";

export * from "./routePaths";

export const routes = [
  {
    path: PORTAL_ROUTE,
    component: Portal,
  },
  {
    path: VALUES_ROUTE,
    component: Preparation.Values,
  },
  {
    path: PURPOSES_ROUTE,
    component: Preparation.Purposes,
  },
  {
    path: VISIONS_ROUTE,
    component: Preparation.Visions,
  },
  {
    path: MISSIONS_ROUTE,
    component: Preparation.Missions,
  },
  // Upcoming Feature
  {
    path: SALPLAN_ROUTE_DETAILS,
    component: Preparation.SalPlan.PlanContent,
  },
  {
    path: SALPLAN_ROUTE,
    component: Preparation.SalPlan,
  },
  {
    path: FOCUS_POSTER_ROUTE_DETAILS,
    component: Preparation.FocusPoster.PosterDetails,
  },
  {
    path: FOCUS_POSTER_ROUTE,
    component: Preparation.FocusPoster,
  },
  {
    path: PREPARATION_ROUTE,
    component: Preparation,
  },
  {
    path: INTENTION_ROUTE,
    component: Affirmation.Intention,
  },
  {
    path: STORY_ROUTE,
    component: Affirmation.Story,
  },
  {
    path: MAGIC_ROUTE,
    component: Affirmation.Magic,
  },
  {
    path: PROBLEM_ROUTE,
    component: Affirmation.Problem,
  },
  {
    path: AREA_ROUTE,
    component: Affirmation.Area,
  },
  {
    path: PERSONAL_ROUTE,
    component: Affirmation.Personal,
  },
  {
    path: CLEAR_AND_PROTECT_ROUTE,
    component: Affirmation.ClearAndProtect,
  },
  {
    path: SUBLIMINAL_AUDIO_ROUTE,
    component: Affirmation.Subliminal.AudioDetail,
  },
  {
    path: SUBLIMINAL_ROUTE,
    component: Affirmation.Subliminal,
  },
  {
    path: CREATEPOSSIBILITY_ROUTE,
    component: Affirmation.CreatePossibility,
  },
  {
    path: AFFIRMATION_ROUTE,
    component: Affirmation,
  },
  {
    path: ARCHIVE_ROUTE,
    component: Communication.Archive,
  },
  {
    path: SESSION_ROUTE,
    component: Communication.Session,
  },
  {
    path: TAPPING_ROUTE,
    component: Communication.Healing.Tapping,
  },
  {
    path: NINE_G_ROUTE,
    component: Communication.Healing.NineG,
  },
  {
    path: HEALING_ROUTE,
    component: Communication.Healing,
  },
  {
    path: DETAIL_ROUTE,
    component: Communication.Healing.Detail,
  },
  {
    path: INNER_ROUTE,
    component: Communication.Healing.Inner,
  },
  {
    path: PARTS_ROUTE,
    component: Communication.Healing.Parts,
  },
  {
    path: DISEASE_ROUTE,
    component: Communication.Healing.Disease,
  },
  {
    path: COMMUNICATION_ROUTE,
    component: Communication,
  },
  {
    path: WAVE_DETAIL_ROUTE,
    component: Frequency.Waves.WaveDetail,
  },
  {
    path: WAVES_ROUTE,
    component: Frequency.Waves,
  },
  {
    path: SOLFEGGIO_ROUTE,
    component: Frequency.Solfeggio,
  },
  {
    path: CHAKRAS_ROUTE,
    component: Frequency.Chakras,
  },
  {
    path: FREQUENCY_ROUTE,
    component: Frequency,
  },
  {
    path: BALANCE_GATE_ROUTE,
    component: Gates.BalanceGate,
  },
  {
    path: MANIFESTATION_GATE_ROUTE,
    component: Gates.ManifestationGate,
  },
  {
    path: GATE_ROUTE,
    component: Gates,
  },
  {
    path: LOGIN_SMARTSWAY_ROUTE,
    component: AutoLogin,
  },
  {
    path: LEARN_ROUTE,
    component: Learning,
  },
  {
    path: TRAIN_ROUTE,
    component: Train,
  },
  {
    path: PLAYLISTS_ROUTE,
    component: Playlists,
  },
  {
    path: FAQ_ROUTE,
    component: FAQ,
  },
  {
    path: T_C_ROUTE,
    component: TermsAndConditions,
  },
  {
    path: SAL_MAGIC_FAQ_ROUTE,
    component: SalMagicFAQ,
  },
  {
    path: DESCRIPTION_ROUTE,
    component: Description,
  },
  {
    path: PURE_TONES_ROUTE,
    component: PureTones,
  },
  {
    path: OTHER_SOURCES_ROUTE,
    component: OtherSources,
  },
];
